import { PALETTE } from '../assets/palette';
import { BALANCE } from '../config/balance';
import type { RngStream } from '../core/rng';
import type { ObjectPool } from './pool';
import type { Particle } from './particles';
import type { Enemy } from './enemies';
import type { Gem } from './gems';

/** 粒子生成助手：击杀爆浆、命中火花、爆炸冲击环、宝石吸附轨迹。 */
export class Fx {
  /** 无头模拟（服务端 AI）时关闭，省掉纯视觉分配开销。 */
  enabled = true;

  constructor(
    private particles: ObjectPool<Particle>,
    private rng: RngStream,
  ) {}

  killBurst(e: Enemy): void {
    if (!this.enabled) return;
    const j = BALANCE.juice;
    for (let i = 0; i < j.killParticles; i++) {
      const p = this.particles.obtain();
      const a = this.rng.range(0, Math.PI * 2);
      const sp = this.rng.range(j.killParticleSpeed * 0.4, j.killParticleSpeed);
      p.x = e.x;
      p.y = e.y;
      p.vx = Math.cos(a) * sp;
      p.vy = Math.sin(a) * sp;
      p.maxLife = j.particleLife;
      p.life = p.maxLife;
      p.size = this.rng.range(2, 4.5);
      p.color = e.kind === 'bomber' ? PALETTE.particleTerracotta : PALETTE.particleInk;
      p.ring = false;
    }
  }

  hitSpark(x: number, y: number): void {
    if (!this.enabled) return;
    const j = BALANCE.juice;
    for (let i = 0; i < j.hitParticles; i++) {
      const p = this.particles.obtain();
      const a = this.rng.range(0, Math.PI * 2);
      const sp = this.rng.range(40, 140);
      p.x = x;
      p.y = y;
      p.vx = Math.cos(a) * sp;
      p.vy = Math.sin(a) * sp;
      p.maxLife = 0.25;
      p.life = p.maxLife;
      p.size = 2;
      p.color = PALETTE.particleTerracotta;
      p.ring = false;
    }
  }

  explosion(x: number, y: number, radius: number): void {
    if (!this.enabled) return;
    const j = BALANCE.juice;

    const ring = this.particles.obtain();
    ring.x = x;
    ring.y = y;
    ring.vx = 0;
    ring.vy = 0;
    ring.ring = true;
    ring.size = radius * 0.2;
    ring.maxLife = j.explosionFlashLife;
    ring.life = ring.maxLife;
    ring.color = PALETTE.explosionRing;

    for (let i = 0; i < j.explosionParticles; i++) {
      const p = this.particles.obtain();
      const a = this.rng.range(0, Math.PI * 2);
      const sp = this.rng.range(80, 320);
      p.x = x;
      p.y = y;
      p.vx = Math.cos(a) * sp;
      p.vy = Math.sin(a) * sp;
      p.maxLife = 0.55;
      p.life = p.maxLife;
      p.size = this.rng.range(2, 5);
      p.color = i % 3 === 0 ? PALETTE.particleGold : PALETTE.particleTerracotta;
      p.ring = false;
    }
  }

  gemTrail(g: Gem): void {
    if (!this.enabled) return;
    const p = this.particles.obtain();
    p.x = g.x;
    p.y = g.y;
    p.vx = 0;
    p.vy = 0;
    p.ring = false;
    p.maxLife = 0.22;
    p.life = p.maxLife;
    p.size = 2.2;
    p.color = PALETTE.particleGold;
  }

  /** 开火口扩散小环。 */
  muzzle(x: number, y: number): void {
    if (!this.enabled) return;
    const p = this.particles.obtain();
    p.x = x; p.y = y; p.vx = 0; p.vy = 0;
    p.ring = true;
    p.size = 3;
    p.maxLife = 0.18;
    p.life = p.maxLife;
    p.color = PALETTE.particleTerracotta;
  }

  /** 回旋镖飞行残影。 */
  trail(x: number, y: number): void {
    if (!this.enabled) return;
    const p = this.particles.obtain();
    p.x = x; p.y = y; p.vx = 0; p.vy = 0;
    p.ring = false;
    p.maxLife = 0.2;
    p.life = p.maxLife;
    p.size = 2.4;
    p.color = PALETTE.particleTerracotta;
  }
}
